import React, {Component} from "react";
import "./zocial.css";
import "./Login.css";
import "./Navigation.css";
import "./styles.css";
import "../../Common/Common.css";
import {RESOURCE_BASE_URL, BASE_URL} from "../../../configuration";
import axios from 'axios';
import App from "../../../App";

class EmailVerify extends Component {

    constructor(props) {
        super(props);

        this.redirectToHome = this.redirectToHome.bind(this);
    }

    componentDidMount() {
        this.redirectToHome();
        // var x = document.getElementById("to_hide_navbar");
        // var y = document.getElementById("To_Hide_Navbar");
        // x.style.display = 'none';
        // y.style.display = 'none';
    }

    componentWillUnmount() {
        // var x = document.getElementById("to_hide_navbar");
        // var y = document.getElementById("To_hide_Navbar");
        // x.style.display = 'block';
        // y.style.display = 'block';
    }

    redirectToHome = () => {
        let pathArray = window.location.pathname.split('/');
        let tokenString = pathArray[3];
        console.log("pathArray ===>" + RESOURCE_BASE_URL+tokenString);
        axios.get(RESOURCE_BASE_URL + "api/user-new/email/verify/" + tokenString)
        .then((res => {
            console.log("payload ==> ", res.data);
            if (res.data.payload === "E401US11") {
                window.location.href = BASE_URL + 'expired-email';
                console.log("Email verify token expired");
            } else {

                if (res.data.message === 'User email already verified') {
                    window.location.href = BASE_URL + 'alreadyVerified'
                } else {

                    let axiosConfig = {
                        headers: {
                            'Authorization': tokenString.toString()
                        }
                    };
                    axios.get(RESOURCE_BASE_URL + 'api/user-new', axiosConfig)
                        .then((res) => {
                            let userRole = res.data.payload.userRoles;
                            localStorage.setItem("userRole", userRole);
                        }).catch((err) => {
                        console.log("Get user Id error", err);
                    })

                    let newTokenString = "Bearer " + tokenString;
                    localStorage.setItem("logStatus", "logged");
                    localStorage.setItem("tokenString", newTokenString);
                    window.location.href = BASE_URL + 'order/all';
                }
            }
            // if (res.data.payload === "SUS00001") {
            //     window.location.href = BASE_URL;
            // }
        }))

    }

    render() {
        return(
            <div></div>
        )
    }

}
export default EmailVerify;



// WEBPACK FOOTER //
// ./src/components/Site/Login/EmailVerify.js